export default {
	error: 'Fehler',
	warning: 'Warnung',
	info: 'Hinweis',
	success: 'Erfolg',
	message: 'Nachricht',
	close: 'Schließen',
	'form-description': 'Formular-Felder, die mit einem Sternchen (*) gekennzeichnet sind, sind Pflichtangaben.',
	new: 'Neu',
	'no-entries': 'Es sind keine Einträge vorhanden.',
	'change-order': 'Sortierung von {{colLabel}} ändern',
	'action-running': 'Aktion wird ausgeführt...',
	'action-done': 'Aktion abgeschlossen',
	pagination: 'Paginierung',
	'page-first': 'Direkt zur ersten Seite',
	'page-back': 'Eine Seite zurück',
	'page-next': 'Eine Seite weiter',
	'page-last': 'Direkt zur letzten Seite',
	'entries-per-site': 'Einträge pro Seite',
	page: 'Seite',
	'page-current': 'Seite {{page}}',
	'page-selected': 'Seite {{page}} ist ausgewählt',
	'page-per-site': 'Einträge pro Seite',
	'nav-maximize': 'Navigation maximieren',
	'nav-minimize': 'Navigation minimieren',
	'logo-description': 'Logo {{orgShort}}. Bundesadler mit Flaggenstab und Schriftzug {{orgLong}}',
	'open-link-in-tab': 'Öffnet in neuem Tab.',
	'kolibri-logo': 'Logo von KoliBri',
	'table-pagination-label': 'Paginierung für die Tabelle {{label}}',
	'table-sort-order': 'Priorität {{order}}',
	'avatar-alt': 'Avatar von {{name}}',
	'split-button-dropdown-label-open': 'Optionen anzeigen',
	'split-button-dropdown-label-close': 'Optionen schließen',
	'toast-close-all': 'Alle Benachrichtigungen schließen',
	'error-list': 'Fehlerliste',
	'error-list-message': 'Bitte korrigieren Sie folgende Fehler:',
	version: 'Versionsnummer',
	'table-visible-range': 'Einträge {{start}} bis {{end}} von {{total}}',
	'table-selection-all': 'Alle auswählen',
	'table-selection-none': 'Alle abwählen',
	'table-selection-indeterminate': 'Alle auswählen bei teilweiser Auswahl',
	'table-settings': 'Tabellenkonfiguration',
	'table-settings-cancel': 'Abbrechen',
	'table-settings-apply': 'Übernehmen',
	'table-settings-show-column': 'Spalte {{column}} anzeigen',
	'table-settings-column-width': 'Breite von {{column}}',
	'table-settings-move-up': 'Spalte {{column}} nach oben verschieben',
	'table-settings-move-down': 'Spalte {{column}} nach unten verschieben',
	'table-settings-error-all-invisible': 'Mindestens eine Spalte muss sichtbar sein.',
	'table-settings-column-not-hidable': 'nicht ausblendbar',
	dropdown: 'Auswahlliste',
	'nav-label-open': 'Untermenü zu {{label}} öffnen',
	'nav-label-close': 'Untermenü zu {{label}} schließen',
	'close-alert': 'Benachrichtigung schließen',
	'show-password': 'einblenden',
	'hide-password': 'ausblenden',
	'no-results-message': 'Keine Ergebnisse gefunden.',
	'delete-selection': 'Auswahl entfernen',
	'filename-text': 'Datei auswählen oder hier ablegen...',
	'data-browse-text': 'Datei auswählen',
	sort: 'sortieren',
	'pagination-position-top': 'oben',
	'pagination-position-bottom': 'unten',
	'character-limit-hint': 'Es können bis zu {{limit}} Zeichen eingegeben werden.',
	'character-limit-remaining': 'Es sind noch {{remaining}} Zeichen verfügbar.',
	'character-limit-exceeded': 'Es sind {{over}} Zeichen zu viel.',
	'character-counter-current': '{{current}} Zeichen',
	'character-counter-current-of-max': '{{current}}/{{max}} Zeichen',
	'character-counter-current-of-max-aria': '{{current}} von {{max}} Zeichen',
	readonly: 'schreibgeschützt',
};
